import { render, staticRenderFns } from "./DirectiveDashboard.vue?vue&type=template&id=4ed489ed&scoped=true"
import script from "./DirectiveDashboard.vue?vue&type=script&lang=js"
export * from "./DirectiveDashboard.vue?vue&type=script&lang=js"
import style0 from "./DirectiveDashboard.vue?vue&type=style&index=0&id=4ed489ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed489ed",
  null
  
)

export default component.exports